import { DDTableFilterDef } from './DDTableFilters';

export type FilterDefForMerge = Pick<
  DDTableFilterDef,
  'type' | 'query' | 'customHandler' | 'options' | 'submitable' | 'number'
>;

export const mergeUserPreferenceIntoActiveFilters = (
  filters: FilterDefForMerge[],
  userPreference: Record<string, any>,
  persistSearchToUserPrefs: boolean,
  sessionSearch: Record<string, any> = {}
): {
  toggle: Record<string, any[]>;
  search: Record<string, any>;
} => {
  const initialActiveFilters: {
    toggle: Record<string, any[]>;
    search: Record<string, any>;
  } = {
    toggle: {},
    search: {},
  };

  filters.forEach((filterDef) => {
    if (filterDef.type === 'search') {
      const defaultState = {
        input: '',
        select: filterDef.options?.[0]?.id || '',
        submitable: filterDef.submitable,
        customHandler: filterDef.customHandler,
        number: filterDef.number,
        id: filterDef.query,
      };

      if (persistSearchToUserPrefs && !filterDef.customHandler) {
        const pref = sessionSearch[filterDef.query];
        if (pref && pref.input !== undefined && pref.select !== undefined) {
          initialActiveFilters.search[filterDef.query] = {
            ...defaultState,
            input: pref.input,
            select: pref.select,
            submitable: pref.submitable,
          };
        }
      }
    } else if (filterDef.type === 'toggle') {
      const prefValues = userPreference[filterDef.query]?.values;
      if (Array.isArray(prefValues)) {
        initialActiveFilters.toggle[filterDef.query] = [...prefValues];
      } else {
        initialActiveFilters.toggle[filterDef.query] = [];
      }
    }
  });

  return initialActiveFilters;
};
